export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_STATUS = 'AUTH_STATUS';
export const AUTH_SET_PROFILE = 'AUTH_SET_PROFILE';



// WEBPACK FOOTER //
// ./src/constants/auth.js